import { t } from '@framework/i18n';
import React from 'react';
import { PositiveNegativeNumber } from './PositiveNegativeNumber';

export const SiapDataColumns = [
  {
    title: t('siap-data-columns.profile', 'Profilo'),
    dataIndex: 'profiloDm',
    key: 'profiloDm',
  },
  {
    title: t(
      'siap-data-columns.organico-di-fatto',
      'Organico di Fatto',
    ),
    dataIndex: 'organicoFatto',
    key: 'organicoFatto',
  },
  {
    title: t(
      'siap-data-columns-organico-di-diritto',
      'Organico di Diritto',
    ),
    dataIndex: 'organicoDiritto',
    key: 'organicoDiritto',
  },
  {
    title: t(
      'siap-data-columns-carenza-eccedenza',
      'Carenza/Eccedenza',
    ),
    dataIndex: 'carenzaEccedenza',
    key: 'carenzaEccedenza',

    render: (value: number) => <PositiveNegativeNumber value={value} />,
  },
];
